import includes from 'lodash/includes';
import keys from 'lodash/keys';
import reduce from 'lodash/reduce';
import some from 'lodash/some';
import mixpanel from 'mixpanel-browser';

import { isDevelopment, isProdEnv } from 'utils/constants/constants';

if (!isDevelopment) {
  window.mixpanel = mixpanel;
  const campaignKeywords = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid'];
  const forbiddenReferrers = [
    'accounts.google',
    'autods.com',
    'paypal',
    'login.payoneer',
    'auth.ebay',
    'accounts.youtube',
  ];
  const isForbiddenReferrer = some(forbiddenReferrers, (referrer) =>
    document.referrer ? includes(document.referrer, referrer) : true);

  const getQueryParam = (url: string, param: string) => {
    const results: any = new RegExp('[\?&]' + param + '=([^&#]*)').exec(url);

    if (results === null || (results && typeof (results[1]) !== 'string' && results[1].length)) {
      return '';
    }

    return decodeURIComponent(results[1]).replace(/\W/gi, ' ');
  };

  const getParams = (keywordName: string) => reduce(campaignKeywords, (acc, keyword) => {
    const kw = getQueryParam(document.URL, keyword.replace(/[[]/, '\[').replace(/[]]/, '\]'));

    if (kw.length) {
      return { ...acc, [`${keyword} ${keywordName}`]: kw };
    }

    return acc;
  }, {});

  const loaded = () => {
    const params = getParams('[last touch]');
    const firstParams = getParams('[first touch]');

    window.mixpanel?.autods.register({ 'GTM loaded': !!window.google_tag_manager });

    if (!keys(params).length) {
      if (!isForbiddenReferrer) {
        window.mixpanel?.autods.register({
          'utm_source [last touch]': document.referrer,
          'utm_medium [last touch]': 'referrer',
        });
      }
    } else {
      window.mixpanel?.autods.register(params);
    }

    if (!keys(firstParams).length) {
      const registerFirstParams = {
        'utm_source [first touch]': isForbiddenReferrer ? 'direct' : document.referrer,
        'utm_medium [first touch]': isForbiddenReferrer ? 'direct' : 'referrer',
      };

      window.mixpanel?.autods.register_once(registerFirstParams);
    } else {
      window.mixpanel?.autods.register_once(firstParams);
    }
  };

  window.mixpanel.init(
    process.env.REACT_APP_MIXPANEL_TOKEN,
    { debug: !isProdEnv, api_host: process.env.REACT_APP_MIXPANEL_DOMAIN, batch_flush_interval_ms: 1000, loaded },
    'autods',
  );

  window.mixpanel?.autods.register_once({ 'Landing Page [first touch]': document.URL });
}

export const mixpanelTrack = (event: string, data: { [key: string]: any }) => {
  if (!isDevelopment) {
    window.mixpanel?.autods.track(event, data);
  }
};
